import { BrowserRouter } from 'react-router-dom';
import Providers from '@/providers';
import Routing from '@/routing';

const App = () => (
  <Providers>
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
  </Providers>
);
App.displayName = 'App';

export default App;
